"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getScriptConfigParams = void 0;
/* eslint-disable no-empty */
var shared_1 = require("@cian/peperrors/shared");
var getScriptUrl_1 = require("./getScriptUrl");
function getScriptConfigParams() {
    var dataAttributesParams = getParamsFromDataAttributes();
    if (dataAttributesParams) {
        return dataAttributesParams;
    }
    var searchParamsParams = getParamsFromSearchParams();
    if (searchParamsParams) {
        return searchParamsParams;
    }
    throw new shared_1.NotFoundError({
        message: 'Script config params not found',
        domain: 'config.browser.getScriptConfigParams',
        details: {
            src: (0, getScriptUrl_1.getScriptUrl)(),
        },
    });
}
exports.getScriptConfigParams = getScriptConfigParams;
function getParamsFromDataAttributes() {
    var currentScript = document.currentScript;
    if (!currentScript) {
        return;
    }
    var projectName = currentScript.getAttribute('data-projectName');
    var requestId = currentScript.getAttribute('data-requestId');
    if (!projectName) {
        return;
    }
    return { projectName: projectName, requestId: requestId };
}
function getParamsFromSearchParams() {
    var scriptSrc = (0, getScriptUrl_1.getScriptUrl)();
    if (!scriptSrc) {
        return;
    }
    if (scriptSrc.startsWith('//')) {
        scriptSrc = "https:".concat(scriptSrc);
    }
    var scriptURL = new URL(scriptSrc);
    var projectName = scriptURL.searchParams.get('projectName');
    var requestId = scriptURL.searchParams.get('requestId');
    if (!projectName) {
        return;
    }
    return { projectName: projectName, requestId: requestId };
}
//# sourceMappingURL=getScriptConfigParams.js.map